import { GET_ALL_USUARIO } from "../types/usuario.types";
import { GET_USUARIO } from "../types/usuario.types";
import { NEW_USUARIO } from "../types/usuario.types";
import { UPD_USUARIO } from "../types/usuario.types";

const INITIAL_STATE = []


function usuarioReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_USUARIO:
      return [...payload];
    case GET_USUARIO:
      return [...state, payload];
    default:
      return state;
  }
}

export default usuarioReducer;
